import { useEffect, useState, forwardRef } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import { RouteConstants } from '../../constants/RouteConstants';
import { NewOrganizationFormLayout, oauthMobileClientTokenSchema } from '../../util/constants';
import BiButton from '../primitives/buttons/BiButton.primitive';

import LoaderContainer from '../shared/loaderContainer/LoaderContainer';

import Card from '../shared/cards/Card';
import { HTTP_STATUS } from '../../http/constants/http.status';

import { SettingIcon } from '../../assets/components/svgs';
import { init } from 'i18next';
import { getSessionTokenSettings } from '../../http/user-management-services';
import DynamicFormFieldRenderer from '../Reusable/DynamicFormFieldRenderer';
import ActionButtons from './ActionButtons';
import { handleSettingsValidation, validateSettingsSave } from './Utils';
import PickList, { PICKLIST_TYPES } from '../shared/Fields/PickList';

interface OauthMobileClientSettingsProps {
  formData?: any;
  clientName?: any;
  updateOauthClientData?: Function;
  setShowSelectClientModal?: Function;
  oauthSelectedClient?: any;
  setOauthSelectedClient?: any;
  oauthClientData?: any;
  isReadOnly?: any;
  setIsReadOnly?: any;
}

const OauthMobileClientSettings: React.FC<OauthMobileClientSettingsProps> = ({
  formData,
  clientName,
  updateOauthClientData = () => {},
  setShowSelectClientModal = () => {},
  oauthSelectedClient,
  setOauthSelectedClient,
  oauthClientData,
  isReadOnly,
  setIsReadOnly
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  //const [isReadOnly, setIsReadOnly] = useState(true);
  const [mobileClientFormData, setMobileClientFormData] = useState<any>(
    formData ? { ...formData } : {}
  );
  const [formError, setFormError] = useState<any>({});
  const [initialData, setInitialData] = useState(formData);

  const postUpdateSettings = () => {
    setInitialData(mobileClientFormData);
    updateOauthClientData(mobileClientFormData);
    setIsReadOnly(true);
    setIsLoading(false);
  };

  const getCardTitle = (clientType: any) => {
    let cardTitle = clientType;
    // switch (clientType) {
    //   case 'portal_client':
    //     cardTitle = t('T_OAUTH_PORTAL_CLIENT_SETTINGS');
    //     break;
    //   case 'mobile_client':
    //     cardTitle = t('T_OAUTH_MOBILE_CLIENT_SETTINGS');
    //     break;
    //   case 'oidc_pkce':
    //     cardTitle = t('T_OAUTH_OIDC_PKCE_CLIENT_SETTINGS');
    //     break;
    //   case 'svcac_client':
    //     cardTitle = t('T_OAUTH_SERVICE_ACCOUNT_CLIENT_SETTINGS');
    //     break;
    // }

    return `${cardTitle} ${t('T_OAUTH_CLIENT_PARAMETERS')}`;
  };

  const resetSettings = () => {
    setMobileClientFormData(initialData);
    setFormError({});
  };
  const handleValidation = () => {
    let formError = handleSettingsValidation(mobileClientFormData, oauthMobileClientTokenSchema, t);
    setFormError(formError);
    return formError;
  };

  const validateSave = () => {
    return validateSettingsSave(mobileClientFormData, oauthMobileClientTokenSchema);
  };

  return (
    <LoaderContainer isLoading={isLoading}>
      <div className="flex w-3/5 flex-col overflow-visible px-2 py-3">
        <Card
          title={getCardTitle(clientName)}
          icon={SettingIcon}
          alt={getCardTitle(clientName)}
          height={''}
          width={''}
          className=""
          showCardHeader={true}
          actions={
            <ActionButtons
              settingKey={'oauthSettings'}
              settingType={`${clientName}`}
              formData={mobileClientFormData}
              callback={postUpdateSettings}
              setIsReadOnly={setIsReadOnly}
              setIsLoading={setIsLoading}
              isReadOnly={isReadOnly}
              initialData={initialData}
              resetSettings={resetSettings}
              handleValidation={handleValidation}
              validateSave={validateSave}
            />
          }
        >
          <div className="flex w-full flex-col overflow-visible px-2 py-3">
            <PickList
              fieldKey={'clientName'}
              label={t('T_CLIENT_NAME')}
              required={false}
              fieldValues={['clientName']}
              selectedItems={oauthSelectedClient}
              onSelectedChange={(item: any) => {
                setOauthSelectedClient(item);
              }}
              items={oauthClientData}
              disabled={isReadOnly}
              readOnly={false}
              hasMore={false}
              type={PICKLIST_TYPES.SINGLE}
            />
          </div>
          <div className="mb-5 flex w-full flex-col flex-wrap">
            <div className="flex w-full flex-wrap">
              <DynamicFormFieldRenderer
                dynamicFormData={oauthMobileClientTokenSchema}
                formData={mobileClientFormData}
                setFormData={setMobileClientFormData}
                formError={formError}
                setFormError={setFormError}
                layout={NewOrganizationFormLayout.twoColumn}
                editable={!isReadOnly}
                disabled={isReadOnly}
              />
            </div>
          </div>
        </Card>
      </div>
    </LoaderContainer>
  );
};

export default OauthMobileClientSettings;
